import { render, staticRenderFns } from "./CompBotaoExibirOcultarColuna.vue?vue&type=template&id=629ebec2&"
import script from "./CompBotaoExibirOcultarColuna.vue?vue&type=script&lang=js&"
export * from "./CompBotaoExibirOcultarColuna.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports